import axios from '@/utils/axios'
const rootUrl = 'jurisdiction/website/account/'
const api = {
  ResetPwd: rootUrl + 'resetPwd',
  AccountPage: rootUrl + 'accountPage',
  AccountDetail: rootUrl + 'accountDetail',
  AddAccount: rootUrl + 'addAccount',
  EditAccount: rootUrl + 'editAccount',
  CancellAccount: rootUrl + 'cancellAccount',
  OpenAccount: rootUrl + 'openAccount',
  unLockAccount: rootUrl + 'unlock',
  GetAccountInfoByLogin: rootUrl + 'getAccountInfoByLogin',
  ExportPage: rootUrl + 'exportPage',
  RedDot: rootUrl + 'redDot',
  GetSchedule: rootUrl + 'getSchedule',
  EditSchedule: rootUrl + 'editSchedule',
}

/**
 *  用户修改密码
 */
export function resetPwd(parameter) {
  return axios.formRequest.post(api.ResetPwd, parameter)
}

/**
 *  人员翻页列表
 */
export function accountPage(parameter) {
  return axios.formRequest.post(api.AccountPage, parameter)
}

/**
 *  人员详情接口
 */
export function accountDetail(account_id) {
  return axios.formRequest.post(api.AccountDetail, { account_id })
}

/**
 *  添加人员接口
 */
export function addAccount(parameter) {
  return axios.formRequest.post(api.AddAccount, parameter)
}

/**
 *  人员编辑接口
 */
export function editAccount(parameter) {
  return axios.formRequest.post(api.EditAccount, parameter)
}

/**
 *  人员注销
 */
export function cancellAccount(account_id, cancell_reason, function_name) {
  return axios.formRequest.post(api.CancellAccount, {
    account_id,
    cancell_reason,
    function_name,
  })
}
/**
 *  人员启用
 */
export function openAccount(account_id) {
  return axios.formRequest.post(api.OpenAccount, { account_id })
}
/**
 *  人员解锁
 */
export function unLockAccount(account_id) {
  return axios.formRequest.post(api.unLockAccount, { account_id })
}
/**
 *  登录用户信息
 */
export function getAccountInfoByLogin() {
  return axios.formRequest.post(api.GetAccountInfoByLogin, {})
}

/**
 *  我的下载列表接口
 */
export function exportListPage(parameter) {
  return axios.formRequest.post(api.ExportPage, parameter)
}
/**
 *  红点接口 已经废除 20190418
 */
// export function redDot() {
//   return axios.formRequest.post(api.RedDot, {});
// }

/**
 *  获取日程
 */
export function getSchedule(date) {
  return axios.formRequest.post(api.GetSchedule, { date })
}

/**
 *  编辑日程
 */
export function editSchedule(date, content) {
  return axios.formRequest.post(api.EditSchedule, { date, content })
}

/**
 * 下载类型
 */
export function exportTypeList() {
  return axios.formRequest.post(
    'jurisdiction/website/account/exportTypeList',
    {},
  )
}

/**
 *  添加绑定次数
 */
export function addBindNum(account_id) {
  return axios.formRequest.post('jurisdiction/website/account/addBindNum', {
    account_id,
  })
}

/**
 *  体验列表
 */
export function testAccountPage(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/account/testAccountPage',
    parameter,
  )
}

/**
 *  体验账号详情
 */
export function testAccountRow(account_id) {
  return axios.formRequest.post('jurisdiction/website/account/testAccountRow', {
    account_id,
  })
}

/**
 *  添加体验账号
 */
export function editTextAccount(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/account/editTextAccount',
    parameter,
  )
}

/**
 *  绑定微信列表
 */
export function weiXinPage(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/account/weiXinPage',
    parameter,
  )
}

/**
 *  解绑微信
 */
export function unBindWeiXin(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/wei_xin/unBindWeiXin',
    parameter,
  )
}
